import { RouteObject, useMatches as baseUseMatches } from 'react-router-dom';

import { ErrorElement } from '~/pages/ErrorPage/index';
import { ReportsPage } from './pages/Reports';
import { IconType, ClipboardOutlineIcon, BarGraphFillIcon, SuitcaseFillIcon, DocumentCheckOutlineIcon } from './icons';
import { ApplicationsPage } from './pages/Applications';
import { ApplicationDetailsPage } from './pages/ApplicationDetails';
import { IntakeManagementPage } from './pages/IntakeManagement';
import { ProgramCatalogPage } from './pages/ProgramCatalog';
import { ApplicationExportPage } from './pages/ApplicationExport';
import { BookOutlineIcon } from '@applyboard/ui-icons';
import { ProgramEditPage } from './pages/ProgramEdit';
import { ProgramDetailsPage } from './pages/ProgramDetails';

export type Route = {
  name: string;
  path: string;
  crumb?: string;
  icon: IconType;
  hidden?: boolean;
  children?: Route[];
  page: React.ReactNode;
};

export const routes: Route[] = [
  {
    name: 'Applications',
    crumb: 'Applications',
    icon: ClipboardOutlineIcon,
    path: '/applications',
    page: <ApplicationsPage />,
    children: [
      {
        name: 'Application Details',
        crumb: 'Application Details',
        path: ':id',
        icon: ClipboardOutlineIcon,
        page: <ApplicationDetailsPage />,
        children: [
          {
            name: 'Change Primary Program Intake',
            crumb: 'Change Primary Program Intake',
            path: 'program-edit',
            icon: ClipboardOutlineIcon,
            page: <ProgramEditPage />,
          },
        ],
      },
    ],
  },
  {
    name: 'Application Reports',
    crumb: 'Application Reports',
    icon: BarGraphFillIcon,
    path: '/reports',
    page: <ReportsPage />,
  },
  {
    name: 'Program Catalog',
    crumb: 'Program Catalog',
    icon: BookOutlineIcon,
    path: '/program-catalog',
    page: <ProgramCatalogPage />,
    children: [
      {
        name: 'Program Details',
        crumb: 'Program Details',
        path: ':id',
        icon: BookOutlineIcon,
        page: <ProgramDetailsPage />,
      },
    ],
  },
  {
    name: 'Intake Management',
    crumb: 'Intake Management',
    icon: SuitcaseFillIcon,
    path: '/intake-management',
    page: <IntakeManagementPage />,
  },
  {
    name: 'Data Export',
    crumb: 'Data Export',
    icon: DocumentCheckOutlineIcon,
    path: '/application-export',
    page: <ApplicationExportPage />,
  },
];

export const reactRouterV6Routes = routes.map((route) => convertToReactV6(route));

export function useMatches() {
  const matches = baseUseMatches();
  return matches.filter((m) => m.handle).map((m) => m.handle as Route);
}

function convertToReactV6(route: Route): RouteObject {
  if (route.children && route.children.length) {
    return {
      path: route.path,
      handle: route,
      children: [
        {
          path: '',
          index: true,
          element: route.page,
          errorElement: <ErrorElement />,
        },
        ...route.children.map((childRoute) => convertToReactV6(childRoute)),
      ],
    };
  } else {
    return {
      handle: route,
      path: route.path,
      element: route.page,
      errorElement: <ErrorElement />,
      children: route.children?.map((childRoute) => convertToReactV6(childRoute)),
    };
  }
}
